import {useMutation} from "react-query";
import {AbstractPayloadEntity} from "@services/entities/baseEntity";
import {useState} from "react";
import {AxiosError} from "axios";

type QueryResult = {
    isIdle: boolean;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
}

const useCustomMutation = <T extends AbstractPayloadEntity<T['response']>>(
    promise: (params: T, ...args: any[]) => Promise<T['response']>,
): [(params: T, ...args: any[]) => void, T['response'], QueryResult] => {
    //response: mutation onSuccess시의 response 데이터
    const [response, setResponse] = useState<T['response']>(undefined);

    const [customCallback, setCustomCallback] = useState<any>(undefined); // formData Callback

    const customMutation = useMutation<T['response'], AxiosError, T, unknown>(promise, {
        onSuccess: (data, variables: T) => {
            //response data set
            setResponse(data);
            if (variables.callback) {
                variables.callback.length > 0 ? variables.callback(data, variables) : variables.callback();
            }

            customCallback && customCallback();
        },
        onError: (err: AxiosError, variables: T) => {
            //mutation 통신 실패시 response set undefined
            const errorResponse: any = err?.response?.data || {};
            (err.response?.status) && (errorResponse.status = err.response?.status);
            (errorResponse?.content) && (errorResponse.details = errorResponse.content);
            errorResponse.content = undefined;
            setResponse(errorResponse);

            console.log(err);
            console.log(errorResponse);

            if (variables.callback) {
                variables.callback.length > 0 ? variables.callback(err, variables, errorResponse) : variables.callback();
            }
        }
    });

    const executeQuery = (params: T, formDataCallback?: (...args: any[]) => void) => {
        if (formDataCallback) {
            setCustomCallback(formDataCallback);
        }
        customMutation.mutate(params);
    };

    //mutation 실행 함수, mutation onSuccess시의 response return
    return [executeQuery, response, customMutation];
};

export default useCustomMutation;
